<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="1">
          <h5 class="mt-3 text-center">#{{ index + 1 }}</h5>
        </b-col>
        <b-col sm="9">
          <b-row>
            <b-col>
              <p class="mt-1"><b>{{$t('views.excmcasetype.form.customField.customFieldValue.value')}}</b>: {{ item.value }}</p>
              <p class="mb-1"><b>{{$t('views.excmcasetype.form.customField.customFieldValue.defaultValue')}}</b>: <span v-if="item.defaultValue == 0">{{ $t('buttons.no') }}</span><span v-else-if="item.defaultValue == 1">{{ $t('buttons.yes') }}</span></p>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="2" v-if="!updated && !created">
          <b-button class="btn btn-warning float-right mt-0 mb-1" size="sm" @click="edit()">{{ $t('buttons.edit') }}</b-button>
          <b-button class="btn btn-danger float-right mt-0 mb-0" size="sm" @click="deleteItem()">{{ $t('buttons.delete') }}</b-button>
        </b-col>
        <b-col sm="2" v-else>
          <b-button class="btn btn-disabled float-right mt-0 mb-1" size="sm">{{ $t('buttons.edit') }}</b-button>
          <b-button class="btn btn-disabled float-right mt-0 mb-0" size="sm">{{ $t('buttons.delete') }}</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <hr class="mt-1 mb-1">
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import remove from '@/utils/remove'

export default {
  name: 'CustomFieldValue',
  props: {
    item: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    itemObject: function () {
      return this.$store.state.modals.customFieldValue.update.customFieldValueObjectUpdated
    },
    itemIndex: function () {
      return this.$store.state.modals.customFieldValue.update.indexUpdated
    },
    updated () {
      return this.$store.state.excmcustomfield.update.updated
    },
    created () {
      return this.$store.state.excmcustomfield.create.created
    }
  },
  watch: {
    itemIndex: function () {
      this.changeValues()
    },
    itemObject: function () {
      this.changeValues()
    }
  },
  methods: {
    changeValues () {
      if (Object.entries(this.itemObject).length > 0 && this.itemIndex > -1 && this.itemIndex === this.index) {
        this.items.splice(this.itemIndex, 1, this.itemObject)
        this.$store.state.modals.customFieldValue.update.customFieldValueObjectUpdated = {}
        this.$store.state.modals.customFieldValue.update.indexUpdated = -1
      }
    },
    deleteItem () {
      if (this.item['@id']) {
        remove(this.item['@id'], () => {
          this.items.splice(this.index, 1)
        })
      } else {
        this.items.splice(this.index, 1)
      }
    },
    edit () {
      this.$store.state.modals.customFieldValue.update.show = 1
      this.$store.state.modals.customFieldValue.update.customFieldValueObject = this.item
      this.$store.state.modals.customFieldValue.update.index = this.index
    }
  }
}
</script>
